var _style, _ellipse, _rect, _rect2, _rect3, _ellipse2, _ellipse3, _ellipse4, _path, _g, _g2, _path2, _path3, _path4, _line, _ellipse5, _path5, _ellipse6, _path6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 415 415",
    style: {
      enableBackground: "new 0 0 415 415"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EEEEEE;stroke:#616161;stroke-width:5;stroke-miterlimit:10;}\n\t.st1{opacity:0.8;fill:#0F8BB2;stroke:#616161;stroke-miterlimit:10;}\n\t.st2{fill:#293038;stroke:#616161;stroke-miterlimit:10;}\n\t.st3{fill:#0F8BB2;stroke:#616161;stroke-miterlimit:10;}\n\t.st4{opacity:0.8;}\n\t.st5{fill:none;stroke:#616161;stroke-width:7;stroke-miterlimit:10;}\n\t.st6{fill:#E0990A;stroke:#616161;stroke-miterlimit:10;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_31_",
    className: "st0",
    cx: 205.5,
    cy: 207.5,
    rx: 187.7,
    ry: 165
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2_",
    x: 74.1,
    y: 180,
    className: "st1",
    width: 8,
    height: 66.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_4_",
    x: 136.8,
    y: 181,
    className: "st1",
    width: 8,
    height: 66.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6_",
    x: 199.8,
    y: 181,
    className: "st1",
    width: 8,
    height: 66.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1_",
    className: "st2",
    cx: 60.5,
    cy: 246.9,
    rx: 21.6,
    ry: 12.7
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_5_",
    className: "st2",
    cx: 123.3,
    cy: 247.9,
    rx: 21.5,
    ry: 12.7
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_7_",
    className: "st2",
    cx: 186.3,
    cy: 247.9,
    rx: 21.5,
    ry: 12.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st3",
    d: "M108.4,210.4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10_",
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st3",
    d: "M144.8,181.7c0-32-15.2-55.4-36.4-55.4s-34.3,23.4-34.3,54.4h8c0-29,8.6-42.6,27.9-42.6 s26.8,13.6,26.8,43.6H144.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_",
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st3",
    d: "M207.8,181.7c0-31-15.2-54.4-36.4-54.4s-34.6,23.4-34.6,55.4h8c0-30,8.9-43.6,28.2-43.6 s26.8,13.6,26.8,42.6H207.8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st5",
    d: "M318.6,199.9c4.5,2.3,9,4.8,13.1,8.1c6.6,5.3,11.5,12.9,16.6,19.7c6.5,9,13.5,17.6,20.2,26.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st5",
    d: "M257,147.6l55.7,2.1c0,0,24.1-1.8,24.9,12.7c0.8,13.8-2.4,15.8-2.4,15.8s-6.9,4.7-18,5.2 s-3.8-0.2-14.5,0.5c-10.7,0.6-45.7,1.5-45.7,1.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st5",
    d: "M257,255.2v-54.3l37.3,0.3c0,0,12.8,1.4,27,22.1s21.4,31.2,21.4,31.2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "XMLID_28_",
    className: "st5",
    x1: 244.1,
    y1: 256.4,
    x2: 244.2,
    y2: 133.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_8_",
    className: "st6",
    cx: 244.4,
    cy: 253.9,
    rx: 5.4,
    ry: 5.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st5",
    d: "M244.2,132.9l69.3,0.1c0,0,24,1.1,30.7,6.8s10.4,10.8,12.1,15.5c1.1,2.9,1.3,6.2,1.6,9.3 c0.1,1.6,0.4,3.3,0.3,4.9c-0.2,1.9-0.7,3.6-1.3,5.4c-0.7,2.3-1.5,4.6-2.4,6.9c-1,2.2-2.3,3.9-4.1,5.4c-3.2,2.6-6.7,5.1-10.2,7.1 c-3.7,2.2-7.6,3.3-11.8,4c-3.3,0.6-6.7,1.2-10,1.7"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_17_",
    className: "st6",
    cx: 244.4,
    cy: 133.1,
    rx: 5.4,
    ry: 5.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st5",
    d: "M369.4,255.8"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_20_",
    className: "st6",
    cx: 318.8,
    cy: 199.9,
    rx: 5.4,
    ry: 5.8
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_21_",
    className: "st6",
    cx: 367.6,
    cy: 253.1,
    rx: 5.4,
    ry: 5.8
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_23_",
    className: "st6",
    cx: 342.6,
    cy: 254.9,
    rx: 5.4,
    ry: 5.8
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_24_",
    className: "st6",
    cx: 257,
    cy: 200.7,
    rx: 5.4,
    ry: 5.8
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_25_",
    className: "st6",
    cx: 258,
    cy: 253.9,
    rx: 5.4,
    ry: 5.8
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_26_",
    className: "st6",
    cx: 257,
    cy: 147.6,
    rx: 5.4,
    ry: 5.8
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_27_",
    className: "st6",
    cx: 257,
    cy: 185.3,
    rx: 5.4,
    ry: 5.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6a1029c3f46390242de4cefc6f022cbd.svg";
export { ForwardRef as ReactComponent };